module.exports = __webpack_public_path__ + "img/qr.114e5ef2.png";